import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useAgentSessions } from './AgentSessionContext';
import { LocalStorage } from '../../../utils/LocalStorage';

const VISIBILITY_OPTIONS = ['PRIVATE', 'TEAM', 'TEAM_CLIENT'];

export const ShareSettingsModal = ({ session, onClose }) => {
    const { t } = useTranslation();
    const { updateVisibility, entryPoint } = useAgentSessions();
    const [selected, setSelected] = useState(session.visibility || 'PRIVATE');
    const [isSaving, setIsSaving] = useState(false);

    const isPortal = entryPoint === 'portal' || LocalStorage.fetchUserType() === 'CRM_USER';
    const currentVisibility = session.visibility || 'PRIVATE';
    const isDowngrade = selected === 'PRIVATE' && currentVisibility !== 'PRIVATE';

    // Portal: solo PRIVATE y TEAM_CLIENT
    const options = isPortal
        ? VISIBILITY_OPTIONS.filter(v => v !== 'TEAM')
        : VISIBILITY_OPTIONS;

    const handleSave = () => {
        if (selected === currentVisibility) { onClose(); return; }
        setIsSaving(true);
        updateVisibility(session.session_id, selected).then(() => {
            onClose();
        }).finally(() => {
            setIsSaving(false);
        });
    };

    const clientName = session.client_name || '';

    return (
        <Modal isOpen toggle={onClose}>
            <ModalHeader toggle={onClose}>{t('agent_chat.share_title')}</ModalHeader>
            <ModalBody>
                <div className="share-settings">
                    {options.map(option => (
                        <label
                            key={option}
                            className={`share-settings__option ${selected === option ? 'share-settings__option--selected' : ''}`}
                        >
                            <input
                                type="radio"
                                name="visibility"
                                value={option}
                                checked={selected === option}
                                onChange={() => setSelected(option)}
                            />
                            <div className="share-settings__option-content">
                                <span className="share-settings__option-title">
                                    {t(`agent_chat.share_${option.toLowerCase()}`)}
                                </span>
                                <span className="share-settings__option-desc">
                                    {option === 'TEAM'
                                        ? t('agent_chat.share_team_desc', { clientName })
                                        : option === 'TEAM_CLIENT'
                                            ? t('agent_chat.share_team_client_desc')
                                            : t('agent_chat.share_private_desc')
                                    }
                                </span>
                            </div>
                        </label>
                    ))}

                    {isDowngrade && (
                        <div className="share-settings__warning">
                            <i className="fas fa-exclamation-triangle"></i>
                            {t('agent_chat.share_downgrade_warning')}
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onClose}>{t('agent_chat.cancel')}</Button>
                <button className="btn -alt" onClick={handleSave} disabled={isSaving}>
                    {isSaving ? <i className="fas fa-spinner fa-spin"></i> : t('agent_chat.save')}
                </button>
            </ModalFooter>
        </Modal>
    );
};
